'use client'

import { useCallback, useState } from 'react'
import { InfoAlert } from '@/General/InfoAlert'
import { TruckIcon } from '@heroicons/react/24/solid'
import { LoginModal } from '@/MainLayout/Header/TopMenu/LoginModal'
import { useAuth } from '@/Auth/useAuth'
import { useRouter } from 'next/navigation'

const TrackOrder = () => {
  const { isAuthenticated, isResolved } = useAuth()
  const [isLoginOpen, setIsLoginOpen] = useState(false)
  const router = useRouter()

  const handleLoginSuccess = useCallback(() => {
    router.push('/account/orders')
  }, [router])

  const handleClick = useCallback(() => {
    if (!isResolved) return
    if (isAuthenticated) {
      router.push('/account/orders')
    } else {
      setIsLoginOpen(true)
    }
  }, [isAuthenticated, isResolved, router])

  const trackingPrompt = !isResolved
    ? 'Checking your account status...'
    : 'View tracking for all of your orders.'

  return (
    <>
      <LoginModal
        isLoginOpen={isLoginOpen}
        setIsLoginOpen={setIsLoginOpen}
        message="Log in to view tracking for your orders"
        redirectTo="/account/orders"
        onLoginSuccess={handleLoginSuccess}
      />
      <InfoAlert variant="info" className="mt-8">
        <button
          type="button"
          onClick={handleClick}
          className={`m-0 w-full bg-transparent p-0 text-left text-current ${isResolved ? 'cursor-pointer' : 'cursor-wait'}`}
          aria-disabled={!isResolved}
        >
          <div className="mb-2 font-bold text-xl text-gray-900">
            Looking to track a recent order?
          </div>
          <div className="flex items-center">
            <TruckIcon className="mr-3 size-8 flex-shrink-0" />
            <p className="m-0">{trackingPrompt}</p>
          </div>
        </button>
      </InfoAlert>
    </>
  )
}

export default TrackOrder
